import React from 'react'
import { observer } from 'mobx-react-lite'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import { action } from 'mobx'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import { CustomTableLocalRow } from '../CustomTableLocalRow'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import TableCell from '@mui/material/TableCell'
import { stylesRowOpenedNoBorder } from './shared-styles'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'
import { useTheme } from 'theme/useTheme'
import useClasses from 'theme/UseClasses'

interface CustomTableCollapsibleToggleProps<RowData extends AnyObject, RowStore> {
   localRow: CustomTableLocalRow<RowData, RowStore>
}

export const CustomTableCollapsibleToggle = observer(function CustomTableCollapsibleToggle
   <RowData extends AnyObject, RowStore>(
      props: CustomTableCollapsibleToggleProps<RowData, RowStore>
   ) {
   useCustomTableRenderLog('CustomTableCollapsibleToggle')
   const classes = useClasses(stylesRowOpenedNoBorder)
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()
   const theme = useTheme()

   const localStore = useStore(
      sp => ({
         toggleRowCollapsible: action(
            (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
               if (!sp.localRow.collapsibleOpen) {
                  sp.localRow.collapsibleOpen = true
               } else {
                  sp.localRow.collapsibleOpen = false
               }
               event.stopPropagation()
               event.preventDefault()
            }
         ),
         get tooltip() {
            return sp.localRow.collapsibleConfig.toggleTooltip || 'Details'
         },
         get has() {
            return sp.localRow.collapsibleConfig.rowHasCollapsibleDetail || false
         },
         get cellStyle(): React.CSSProperties {
            return {
               whiteSpace: 'nowrap',
               width: '1%',
               padding: theme.spacing(0, 1, 0, 1),
            }
         },
         get buttonStyle(): React.CSSProperties {
            return { margin: '0px' }
         },
      }),
      { ...props }
   )

   return !customTableStore.hasCollapsibleRowDetail ? null : (
      <TableCell
         className={props.localRow.collapsibleOpen ? classes.cellOpened : classes.cellClosed}
         style={localStore.cellStyle}
         align="center">
         {localStore.has && (
            <Tooltip title={localStore.tooltip}>
               <IconButton
                  onClick={localStore.toggleRowCollapsible}
                  style={localStore.buttonStyle}
                  size={customTableStore.size}>
                  {props.localRow.collapsibleOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
               </IconButton>
            </Tooltip>
         )}
      </TableCell>
   )
}
)
